'use strict';

angular.module('app')
  .controller('RegCtrl', function ($scope, $routeParams, Auth, GTM) {

  	var vm = this;

  	vm.auth = Auth;



    //Triggered when the email login form is viewed
    GTM.event('user_login_email_viewed');


  	vm.login = function (credentials) {
  		if ($scope.loginForm.$invalid) {
  			return vm.loginSubmited = true;
  		}
  		
  		vm.loginErrors = false;
      GTM.event('user_login_email_submitted');

  		vm.auth.login(credentials).catch(function(data){
  			vm.loginErrors = data;

        GTM.event('user_login_email_error');
  		});
  	}

    vm.showCaptcha = false;
    vm.createAccount = function (credentials) {
      if ($scope.registrationForm.$invalid) {
        vm.showCaptcha = true;
  			return vm.formSubmited = true;
  		}

  		vm.regErrors = false;

  		vm.auth.registration(credentials).catch(function(data){
  			vm.regErrors = data;
  		});
  	}

    vm.recoverPassword = function (email) {
      if ($scope.recoverForm.$invalid) {
        return vm.recoverSubmited = true;
      }

      vm.recoverErrors = false;

      vm.auth.recoverPassword(email).then(function(data){
        $scope.forgotten = false;
      }, function (error) {
        vm.recoverErrors = error;
      });
    } 

    vm.resetPassword = function (resetPass) {
      if ($scope.resetForm.$invalid) {
        return vm.resetSubmited = true;
      }

      resetPass.token = $routeParams.token;
      resetPass.uid = $routeParams.uid;
      
      vm.resetSubmited = false;

      vm.auth.resetPassword(resetPass).then(function(data){
        $scope.forgotten = false;
      }, function (error) {
        vm.recoverErrors = error;
      });
    }

 });
